import React, {useState} from 'react'
import {KTIcon} from "../../../../../_websoft/helpers"
import notifyToast from "../../../../components/Toast/Toast";
import {deleteDodjeljenuSifruDopu, saveDopSifra, validateSifra} from "../../../../api/paneliDop";

type DopSifra = {
    Id: number
    sifra: string
}

type Props = {
    isOpen: boolean
    onClose: () => void
    sifraId: number | null

    dbSifre: DopSifra[]
    setDbSifre: React.Dispatch<React.SetStateAction<DopSifra[]>>

    newSifre: DopSifra[]
    setNewSifre: React.Dispatch<React.SetStateAction<DopSifra[]>>
}

const DopSifreModal = ({
                           isOpen,
                           onClose,
                           sifraId,
                           dbSifre,
                           setDbSifre,
                           newSifre,
                           setNewSifre
                       }: Props) => {

    const [newSifraInput, setNewSifraInput] = useState('')
    const [savingSifre, setSavingSifre] = useState(false)

    if (!isOpen) return null

    const addSifra = async () => {
        const sifra = newSifraInput.trim()
        if (!sifra) return

        if (dbSifre.some(s => s.sifra === sifra) || newSifre.some(s => s.sifra === sifra)) {
            notifyToast(false, "Šifra već postoji")
            return
        }

        try {
            const res = await validateSifra(sifra)

            if (!res?.valid) {
                notifyToast(false, "Šifra ne postoji")
                return
            }

            const panelSifraId = Number(res?.Id ?? res?.id)

            setNewSifre(prev => [...prev, {Id: panelSifraId, sifra}])
            setNewSifraInput('')

        } catch {
            notifyToast(false, "Greška kod validacije")
        }
    }

    const removeDopSifra = async (item: DopSifra) => {
        try {
            await deleteDodjeljenuSifruDopu(item.Id)
            setDbSifre(prev => prev.filter(s => s.Id !== item.Id))
            notifyToast(true, "Šifra uklonjena")
        } catch {
            notifyToast(false, "Greška kod brisanja")
        }
    }

    const removeNewSifra = (sifra: string) => {
        setNewSifre(prev => prev.filter(s => s.sifra !== sifra))
    }

    const saveSifre = async () => {

        console.log(sifraId, 'sifra')
        if (!sifraId) {
            notifyToast(false, "Nije odabran DOP")
            return
        }

        try {
            setSavingSifre(true)

            for (const sifra of newSifre) {
                await saveDopSifra({
                    DopId: sifraId,
                    SifraId: sifra.Id
                })
            }

            notifyToast(true, "Sačuvano")
            onClose()

        } catch {
            notifyToast(false, "Greška")
        } finally {
            setSavingSifre(false)
        }
    }

    return (
        <div className="modal fade show d-block" style={{background: 'rgba(0,0,0,0.55)'}}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">

                    <div className="modal-header">
                        <h4>Dodijeljene šifre</h4>
                        <button className="btn btn-sm btn-light" onClick={onClose}>
                            <KTIcon iconName="cross"/>
                        </button>
                    </div>

                    <div className="modal-body">

                        {/* DB */}
                        <div className="mb-5">
                            <h6>Šifre iz baze</h6>

                            {dbSifre.map(item => (
                                <span
                                    key={item.Id}
                                    className="badge fs-4 badge-light-primary me-2 d-inline-flex align-items-center"
                                >
                                {item.sifra}

                                    <span
                                        onClick={() => removeDopSifra(item)}
                                        className="ms-2 text-hover-danger"
                                        style={{
                                            cursor: 'pointer',
                                            fontWeight: 700,
                                            lineHeight: 1
                                        }}
                                    >
                                            ✕
                                        </span>
                                    </span>
                            ))}
                        </div>

                        {/* NEW */}
                        <div className="mb-5">
                            <h6>Nove šifre</h6>

                            {newSifre.map(item => (
                                <span key={item.Id} className="badge badge-light-success me-2">
                                    {item.sifra}
                                    <span onClick={() => removeNewSifra(item.sifra)}> ✕ </span>
                                </span>
                            ))}
                        </div>

                        {/* INPUT */}
                        <div className="d-flex gap-2">
                            <input
                                className="form-control"
                                value={newSifraInput}
                                onChange={(e) => setNewSifraInput(e.target.value)}
                            />
                            <button className="btn btn-primary" onClick={addSifra}>
                                Dodaj
                            </button>
                        </div>

                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-light" onClick={onClose}>Zatvori</button>
                        <button className="btn btn-success" onClick={saveSifre}>
                            {savingSifre ? "..." : "Sačuvaj"}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default DopSifreModal